import { useNavigate } from 'react-router-dom';
import classes from './FinanceMenu.module.css';
import { Link } from 'react-router-dom';
import NavBar from '../../components/NavBar/NavBar';

const FinanceMenu = () => {
  const navigate = useNavigate();

  const navigateToIncome = () => {
    navigate('/finanzen/income');
  };

  const navigateToPayouts = () => {
    navigate('/finanzen/payouts');
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className={classes.container}>
      <NavBar fromFinance={true} />

      <div className={classes.navBarPhoneContainer}>
        <header className={classes.header}>
          <div className={classes.backButton} onClick={handleBackClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="22" viewBox="0 0 13 22" fill="none">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.4609 20.0297L10.9309 21.457L0.960938 10.5378L10.9309 0.457031L12.4017 1.9442L3.84334 10.5977L12.4609 20.0297Z"
                fill="#101010"
              />
            </svg>
          </div>
          <Link to='/' className={classes.logoLink}>
            <div className={classes.logoContainer}>
              <svg xmlns="http://www.w3.org/2000/svg" width="53" height="19" viewBox="0 0 53 19" fill="none">
                <path d="M50.5002 9.5C51.8809 9.5 53.0002 8.38071 53.0002 7C53.0002 5.61929 51.8809 4.5 50.5002 4.5C49.1195 4.5 48.0002 5.61929 48.0002 7C48.0002 8.38071 49.1195 9.5 50.5002 9.5Z" fill="#FF003E"/>
                <path d="M9.93692 9.78445L8.58239 9.67069C5.23081 9.39942 4.10204 9.0494 4.10204 8.2881C4.10204 7.5268 5.52603 7.10677 8.46083 7.10677C11.5606 7.10677 12.8109 7.51805 13.0714 8.62062L13.1148 8.79563H16.5185L16.4838 8.55062C16.1452 5.64542 13.5577 4.23658 8.58239 4.23658C3.60712 4.23658 1.05437 5.61917 1.05437 8.33185C1.05437 10.817 3.09483 12.0158 8.11352 12.4709L9.32912 12.5846C12.6546 12.8734 13.8876 13.3109 13.8876 14.186C13.8876 15.1398 12.3681 15.6298 9.36385 15.6298C5.96017 15.6298 4.2236 14.991 4.05863 13.6697L4.03258 13.4772H0.628906V13.7135C0.785197 16.8899 3.63317 18.5 9.10336 18.5C14.5736 18.5 16.944 16.9949 16.944 14.0285C16.944 11.3858 14.9817 10.1957 9.93692 9.78445Z" fill="#1F1F1F"/>
                <path d="M42.1415 4.67403V10.3444C42.1415 13.5209 40.0663 15.4897 36.7321 15.4897C33.5976 15.4897 32.3733 14.0809 32.3733 10.4582V4.67403H21.8497V0.5L18.7152 1.83009V13.7834C18.7152 17.0823 20.2954 18.4912 24.003 18.4912C25.2968 18.4912 26.5384 18.2724 27.589 18.0537L27.7627 18.0187V15.2097L27.5022 15.2622C26.139 15.5422 25.5312 15.6473 24.5587 15.6473C22.7614 15.6473 21.8497 15.2185 21.8497 12.8646V7.2992H30.793L29.1433 8.55928V11.482C29.1433 16.2685 31.1577 18.4912 35.4731 18.4912C38.2603 18.4912 40.5525 17.5199 42.1415 15.6648V18.0537H45.3715V4.67403H42.1415Z" fill="#1F1F1F"/>
              </svg>
            </div>
          </Link>
        </header>
      </div>

      <div className={classes.scrollContainer}>
        <h1 className={`titleSemibold2 ${classes.screenTitle}`}>Finanzen</h1>

        <div className={classes.sectionCard}>
          
          <div className={classes.item} onClick={navigateToIncome}>
              <span>Einkünfte</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                  <path d="M7.99844 7.1998L7.59844 7.5998L1.49844 13.6998L0.398438 12.5998L5.79844 7.1998L0.398438 1.3998L1.59844 0.299805L7.99844 7.1998Z" fill="#696F76"/>
              </svg>
          </div>

          <div className={classes.item} onClick={navigateToPayouts}>
              <span>Auszahlungen</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                  <path d="M7.99844 7.1998L7.59844 7.5998L1.49844 13.6998L0.398438 12.5998L5.79844 7.1998L0.398438 1.3998L1.59844 0.299805L7.99844 7.1998Z" fill="#696F76"/>
              </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinanceMenu;

